import * as THREE from "three";

export default function findLogoAndRotateProduct (product: THREE.Object3D): void {
    const logo = product.getObjectByName("logo_main");

    if (logo) {
        logo.layers.set(5); // Exclude logo from raycasting

        logo.updateWorldMatrix(true, true);
        const box = new THREE.Box3().setFromObject(logo);
        const center = box.getCenter(new THREE.Vector3());
        const angle =  Math.atan2(center.z, center.x);

        product.rotation.y = angle - Math.PI / 2;
    }
}